//==== ajax


function addCustomProductToCart(variantId, name = '', url = '', isPrint = false) {
    try {
        const data = {
            id: variantId,
            quantity: 1,
            ...(isPrint && {
                properties: {
                    'Image': name,
                    'Image URL': url,
                    'Product': variant_selected_or_first.name
                }
            })
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Product added to cart:', data);
                if (isPrint) {
                    const uploadIcon = document.getElementById('uploadIcon');
                    uploadIcon.classList.remove('loading-spinner');
                    uploadIcon.innerHTML = `
                <!-- Upload Icon SVG -->
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                    <g fill="currentColor">
                        <path d="M7 4.174V11h2V4.174l2.608 2.236l1.302-1.518L8 .682l-4.91 4.21L4.392 6.41z"/>
                        <path d="M3 13v-3H1v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3h-2v3z"/>
                    </g>
                </svg>
            `;
                }

            })
            .catch(error => {
                console.error('Error adding product to cart:', error);
            });

    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}



function addCustomShirtPrintToCart(variantId, name = '') {
    try {
        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.disabled = true;
        });
        const data = {
            id: variantId,
            quantity: 1,

            properties: {
                'Product': name,
            }

        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Product added to cart:', data);
                const checkboxes = document.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach(checkbox => {
                    checkbox.disabled = false;
                });

            })
            .catch(error => {
                console.error('Error adding product to cart:', error);
            });

    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}
function removeCustomShirtPrintFromCart(variantId) {
    try {
        // Fetch cart contents to find the line item ID
        fetch('/cart.js')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(cart => {
                // Log the cart items for debugging
                console.log('Cart contents:', cart.items);

                // Find the line item key for the given variant ID
                const lineItem = cart.items.find(item => item.variant_id === parseInt(variantId, 10));
                
                // Log the found line item or the absence of it
                if (lineItem) {
                    console.log('Found line item:', lineItem);

                    // Remove item from cart
                    fetch(`/cart/change.js`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            id: lineItem.key,
                            quantity: 0,
                        }),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.json();
                        })
                        .then(data => {
                            //console.log('Product removed from cart:', data);
                        })
                        .catch(error => {
                           // console.error('Error removing product from cart:', error);
                        });
                } else {
                    //console.log('Item not found in cart with variantId:', variantId);
                }
            })
            .catch(error => {
               // console.error('Error fetching cart:', error);
            });

    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}


function getCurrentVariantId() {

    try {
        const currentUrl = new URL(window.location.href);
        const params = new URLSearchParams(currentUrl.search);
        return params.get('variant');
    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}

function handleVariantChange() {
    try {
        const currentVariantId = getCurrentVariantId();
        console.log(`Variant ID changed to: ${currentVariantId}`);
        // Your code to handle the variant change goes here

        // Get the current URL
        const currentUrl = new URL(window.location.href);
        const params = new URLSearchParams(currentUrl.search);
        const variantId = params.get('variant');


        // Set the 'variant' parameter in the URL
        currentUrl.searchParams.set('variant', variantId);

        console.log(`${currentUrl.origin}${currentUrl.pathname}?variant=${variantId}`);

        // Update the URL without reloading the page
        //window.history.replaceState({}, '', currentUrl);
        // window.location.assign(`${currentUrl.origin}${currentUrl.pathname}?variant=${variantId}`);
        // window.location.replace(`${currentUrl.origin}${currentUrl.pathname}?variant=${variantId}`);

    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}